// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import axios from "axios";
import { encryptHeader } from "../utils/encryptHeader";
const API_ENDPOINT = require("../config/server");
const { getSession } = require("../utils/sessionstore");

export async function getRecentDashboards(token, clientid) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "GET_RECENTS",
      Method: "GET",
    },

    Parameters: {
      clientid: clientid,
    },
  };

  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV": iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
  };

  const response = await axios(axiosoptions);

  return response.data;
}

// userId is taken from the bearer token server side, so it is not sent here.
export async function addRecentDashboard(token, payload) {
  let formattedPayload = {
    Dashboard_Details: {
      Dashboard_Name: "Lobby",
      Dashboard_Version: "V1",
      API_Route: "CREATE_RECENT",
      Method: "POST",
    },

    Parameters: {
      data: { recent: payload },
    },
  };

  const { encryptedHeader, iv } = await encryptHeader(getSession("session_hwai"));

  const axiosoptions = {
    url: `${API_ENDPOINT}`,
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      session_id: getSession("session_id"),
      Authorization: `Bearer ${encryptedHeader}`,
      "IV": iv,
      'Accept-Encoding': 'identity'
    },
    data: formattedPayload,
  };

  const response = await axios(axiosoptions);

  return response.data;
}
